/**
 * Builds a collision-safe cache key for complementary recommendations. The source SKU is
 * part of the identity because different variants of one product can return different results.
 */
const getComplementaryCarouselKey = (productId, skuId) => JSON.stringify([productId || null, skuId || null]);

export default getComplementaryCarouselKey;
